/* eslint-disable react/no-danger */

import React from "react";

const WatchLive = () => (
  <div className="tv-player">
    <div
      className="video__player"
      dangerouslySetInnerHTML={{
        __html: window.livePage && window.livePage.videoIframe,
      }}
    />
  </div>
);

export default WatchLive;
